import { render, staticRenderFns } from "./cClassificationList.vue?vue&type=template&id=d88dcb7c&scoped=true"
import script from "./cClassificationList.vue?vue&type=script&lang=js"
export * from "./cClassificationList.vue?vue&type=script&lang=js"
import style0 from "./cClassificationList.vue?vue&type=style&index=0&id=d88dcb7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88dcb7c",
  null
  
)

export default component.exports